import { useCallback, useEffect, useRef } from "react";

export const useGenericDebounce = (delay=1000) => {
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);

  const debounce = useCallback(
    (callback: (...args: any[]) => void, value: any) => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }

      timeOutRef.current = setTimeout(() => {
        callback(value);
      }, delay);
    },
    [],
  );

  useEffect(() => {
    return () => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
    };
  }, []);

  return {debounce}

};
